import APIService from '@/services/APIService.js';

export default {
  getBasesDadosLiberadas() {
    return APIService.apiCall().get('/tabelas/get_tabelas_disponiveis');
  },

  getViewsCampos(view) {
    return APIService.apiCall().get(`/tabelas/get_tabela_campos/${view}`);
  },

  getViewByNome(view) {
    return APIService.apiCall().get(`/tabelas/get_view_by_nome/${view}`);
  },

  getTabelaResumo() {
    return APIService.apiCall().get('/tabelas/get_tabela_resumo');
  },

  getEstruturaBasesDadosLiberadas() {
    return APIService.apiCall().get('/tabelas/getEstruturaBasesDadosLiberadas');
  },

  getEstrutura(tabela) {
    return APIService.apiCall().get(`/tabelas/getEstrutura/${tabela}`);
  }
};
